<template>
    <el-card class="page_card" ref="card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>对账单管理</span>
        </div>
        <el-form inline ref="selectForm" :model="selectForm">
            <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom"
                    :loading="is_select">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="最后对账时间">
                <el-date-picker
                    v-model="selectForm.time"
                    type="datetime"
                    style="width: 100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择最后对账时间">
                </el-date-picker>
            </el-form-item> -->
            <el-form-item label="最后对账时间">
                <el-date-picker
                    v-model="selectForm.timeRange"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="发送状态">
                <el-select v-model="selectForm.isValid" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未发送" value="0"></el-option>
                    <el-option label="已发送" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="确认状态">
                <el-select v-model="selectForm.cfmd" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未确认" value="0"></el-option>
                    <el-option label="已确认" value="1"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="创建时间">
                <el-date-picker
                    v-model="selectForm.timeRange"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item> -->

            <el-button plain type="primary" :loading="is_post" @click="select">查 询</el-button>
            <el-button plain @click="resetSelect" :loading="is_post">重 置</el-button>
            <el-button plain type="primary" @click="resetSure" :loading="is_post" v-can="['btn:confirmation_statement']">确 认</el-button>
            <el-button plain type="danger" @click="resetDelete" :loading="is_post" v-can="['btn:delete_statement']">删 除</el-button>
            <el-button plain type="success" :loading="is_post" @click="make_dzd" v-can="['btn:add_billlist']"><svg-icon icon-class="pdf" /> 生成对账单</el-button>
            <el-button plain type="warning" :loading="is_post" @click="send_select" v-can="['btn:push_bill']"><i class="el-icon-position" /> 发送至客户({{this.selected.length}})</el-button>
        </el-form>
        <el-table :data="data" stripe @selection-change="handleSelectionChange" v-loading="is_loading" :max-height="tableMaxHeight" v-if="showtable">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="公司名称" width="240">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.comName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="对账开始时间" width="150">
                <template slot-scope="scope">
                    {{scope.row.cycleStartDate}}
                </template>
            </el-table-column>
            <el-table-column label="对账结束时间" width="150">
                <template slot-scope="scope">
                    {{scope.row.cycleEndDate}}
                </template>
            </el-table-column>
            <!-- <el-table-column label="累计装液量(吨)">
                <template slot-scope="scope">
                    <span class="success_text">{{scope.row.netWeightTotal}} 吨</span>
                </template>
            </el-table-column> -->
            <el-table-column label="上期余额(元)" align="right" width="120">
                <template slot-scope="scope">
                    <span class="danger_text" v-if="scope.row.lastCycleBalance < 0">{{parseNums(scope.row.lastCycleBalance)}} </span>
                    <span class="success_text" v-else>{{parseNums(scope.row.lastCycleBalance)}} </span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="累计打款(元)">
                <template slot-scope="scope">
                    <span>{{scope.row.paymentTotal}} 元</span>
                </template>
            </el-table-column>
            <el-table-column label="累计货款(元)">
                <template slot-scope="scope">
                    <span>{{scope.row.spendTotal}} 元</span>
                </template>
            </el-table-column>
            <el-table-column label="全局优惠抵扣(元)">
                <template slot-scope="scope">
                    <span>{{scope.row.discountTotal}} 元</span>
                </template>
            </el-table-column> -->
            <el-table-column label="提货量(吨)" align="right" width="90">
                <template slot-scope="scope">
                    <span>{{scope.row.netWeightTotal}} </span>
                </template>
            </el-table-column>
            <el-table-column label="销售额(元)" align="right" width="120">
                <template slot-scope="scope">
                    <span>{{parseNums(scope.row.spendForGoods)}} </span>
                </template>
            </el-table-column>
            <el-table-column label="本期收款(元)" align="right" width="120">
                <template slot-scope="scope">
                    <span>{{parseNums(scope.row.paymentTotal)}} </span>
                </template>
            </el-table-column>
            <el-table-column label="本期余额(元)" align="right" width="120">
                <template slot-scope="scope">
                    <span class="danger_text" v-if="scope.row.thisCycleBalance < 0"> {{parseNums(scope.row.thisCycleBalance)}} </span>
                    <span class="success_text" v-else> {{parseNums(scope.row.thisCycleBalance)}} </span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="生成时间" width="150">
                <template slot-scope="scope">
                    {{scope.row.operTime}}
                </template>
            </el-table-column> -->
            <el-table-column label="发送状态">
                <template slot-scope="scope">
                    <span class="success_text" v-if="scope.row.isValid">已发送</span>
                    <span class="warning_text" v-else>未发送</span>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <span class="success_text" v-if="scope.row.cfmd">已确认</span>
                    <span class="warning_text" v-else>未确认</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-dropdown trigger="click" placement="bottom-start" @command="clickDrop($event,scope.row)">
                        <el-button type="primary" size="mini" plain>
                            <svg-icon icon-class="many" />
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item class="primary_text" command="detail"> <svg-icon icon-class="view" /> 查看详情</el-dropdown-item>
                            <el-dropdown-item class="primary_text"  v-can="['btn:dzd_cancel']" v-if="scope.row.cfmd" command="cancelConfirm"> <svg-icon icon-class="table" /> 取消确认</el-dropdown-item>
                            <el-dropdown-item class="primary_text" v-can="['btn:confirmation_statement']" v-if="scope.row.cfmd==false" command="sure"> <svg-icon icon-class="table"/> 确认</el-dropdown-item>
                            <el-dropdown-item class="primary_text" v-if="scope.row.cfmd==false" command="delete"> <svg-icon icon-class="del"/> 删除</el-dropdown-item>
                            <el-dropdown-item class="primary_text" v-can="['btn:dzd_export_pdf']" command="pdf" v-if="scope.row.pdfUrl"> <svg-icon icon-class="pdf" /> 查看pdf</el-dropdown-item>
                            <el-dropdown-item class="success_text" v-can="['btn:dzd_export_excel']" command="excel" v-if="scope.row.excelUrl"> <svg-icon icon-class="excel" /> 导出excel</el-dropdown-item>
                            <el-dropdown-item class="warning_text" command="send" v-if="!scope.row.isValid && has_permission('btn:push_bill')"> <i class="el-icon-position" /> 发送至客户</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                @size-change="handleSizeChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :page-sizes="selectForm.pageSizes"
                :hide-on-single-page="false"
                layout="sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>


        <el-dialog :visible.sync="show_detail_dialog" title="" width="70%">
            <bill_detail v-if="show_detail_dialog" :data="active_item"></bill_detail>
            <span slot="footer" class="dialog-footer" v-if="active_item">
                <el-button plain type="primary" size="mini" v-if="active_item.pdfUrl" @click="showPdf(active_item.pdfUrl)"> <svg-icon icon-class="pdf" /> 查看PDF</el-button>
                <el-button plain type="success" size="mini" @click="exportExcel(active_item)" v-if="active_item.excelUrl"> <svg-icon icon-class="excel" /> 导出excel</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="add_dialog" title="生成对账单" width="65%">
            <el-form :model="addForm" ref="addForm" :rules="rules" label-width="160px">
                <!-- <el-form-item label="账单周期" prop="yearMonth">
                    <el-date-picker
                        v-model="addForm.yearMonth"
                        type="month"
                        format="yyyy-MM"
                        style="width: 80%"
                        value-format="yyyy-MM"
                        placeholder="选择月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="对账日">
                    <span class="primary_text" style="font-size: 14px">每月  22 日</span>
                </el-form-item> -->
                <el-form-item label="客户企业" prop="addForm.companyIds">
                    <el-transfer v-model="selectComIDs" :data="company" :filterable="true" :titles="['待选公司', '已选公司']" @change="selectChange"></el-transfer>
                    <!-- <el-select
                        v-model="addForm.companyIds"
                        ref="add_com"
                        multiple
                        collapse-tags
                        style="width: 80%"
                        filterable
                        remote
                        reserve-keyword
                        @change="selectChange"
                        placeholder="请选择">
                        <el-option
                            :disabled="addForm.companyIds.includes(0) && item.id != 0"
                            v-for="item in company"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="对账结束时间" prop="endDate">
                    <el-date-picker
                        v-model="addForm.endDate"
                        type="date"
                        format="yyyy-MM-dd"
                        style="width: 80%"
                        value-format="yyyy-MM-dd"
                        placeholder="选择时间">
                    </el-date-picker>
                </el-form-item>
<!--                <el-form-item label="已有对账单处理方式">-->
<!--                    <el-radio-group v-model="addForm.mode" size="small">-->
<!--                        <el-radio-button label="0" disabled>覆盖</el-radio-button>-->
<!--                        <el-radio-button label="1" >跳过</el-radio-button>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
                <el-form-item label="">
                    <el-button plain type="primary" @click="addSubmit" :loading="is_post">确认生成</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
import request from '@/utils/request'
import bill_detail from './bill_detail'
import {deepClone} from "@/utils/index"
import can from "@/directive/can/index.js"
import {mapGetters} from 'vuex'


export default {
    name: 'bill_list',
    components:{
        bill_detail
    },
    directives:{can},
    computed:{
        ...mapGetters([
            'permissions',
            'roles'
        ])
    },
    data(){
        return{
            is_ok:false,
            is_post:false,
            is_select:false,
            is_loading:false,
            show_detail_dialog:false,
            data:[],
            total:0,
            company:[],
            selectForm:{
                comId:"",
                isValid:'',
                cfmd:'',
                timeRange:[],
                pageNum:1,
                pageSize:10,
                pageSizes:[10, 20, 50, 100]
            },
            selected:[],
            addForm:{
                endDate:"",
                mode:1,
                companyIds:[]
            },
            add_dialog:false,
            componys:[],
            all_com:[],
            rules:{
                endDate:[
                    { required: true, message: '请选择一个月', trigger: 'blur' },
                ],
                companyIds:[
                    { required: true, message: '请选择至少一个企业', trigger: 'blur' },
                ]
            },
            tableMaxHeight:0,
            showtable:false,
            active_item:null,
            selectComIDs: []
        }
    },
    methods:{
        generateData(){
            var data = [];
            for (let i = 1; i <= 15; i++) {
            data.push({
                key: i,
                label: `备选项 ${ i }`,
                disabled: i % 4 === 0
            });
            }
            return data;
        },
        select(){
            this.getData();
        },
        resetSelect(){
            this.$refs["selectForm"].resetFields();
            this.selectForm={
               comId:"",
                isValid:'',
                cfmd:'',
                timeRange:[],
                pageNum:1,
                pageSize:10
            },
            this.getData()
        },


        clickDrop(type,item){
            this.active_item = item;
            if(type == "pdf"){
                window.open(item.pdfUrl,"_blank");
            }else if(type == "excel"){
                window.open(item.excelUrl,"_blank");
            }else if(type == "sure"){
                request.post("finance/dzd/confirm",{dzdId:item.id}).then(res=>{
                    this.getData();
                    this.$message.success("确认成功!");
                }).catch(err=>{
                });
            }else if(type == "delete"){
                request.post("finance/dzd/delete",{dzdId:item.id}).then(res=>{
                    this.getData();
                    this.$message.success("删除成功!");
                }).catch(err=>{
                });
            }else if(type == "detail"){
                this.show_detail_dialog = true;
            }else if(type=='cancelConfirm'){
                request.post("finance/dzd/cancel",{dzdId:item.id}).then(res=>{
                    this.getData();
                    this.$message.success("取消确认成功!");
                }).catch(err=>{
                });
            }else if(type == "send"){
                this.is_post = true;
                request.post("finance/send_to_customer",{dzdIds:[item.id]}).then(res=>{
                    this.getData();
                    this.$message.success("操作成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            }
        },
        showPdf(url){
            window.open(url,"_blank");
        },
        exportExcel(){
            window.open(this.active_item.excelUrl,"_blank");
        },
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        handleSizeChange(val){
            this.selectForm.pageSize = val;
            this.getData();
        },
        make_dzd(){
            this.add_dialog = true;
        },
        resetSure(){
            if(this.selected.length==0){
                this.$message.error("请选择相对应的数据！");
            }else{
                let arr = [];
                for(let item of this.selected){
                    arr.push(item.id);
                }
                request.post("finance/dzd/batch_confirm",{dzdIds:arr}).then(res=>{
                    this.getData();
                    this.$message.success("确认成功!");
                }).catch(err=>{
                });
            }

        },
        resetDelete(){
            if(this.selected.length==0){
                this.$message.error("请选择相对应的数据！");
            }else{
                let arr = [];
                for(let item of this.selected){
                    arr.push(item.id);
                }
                request.post("finance/dzd/batch_delete",{dzdIds:arr}).then(res=>{
                    this.getData();
                    this.$message.success("删除成功!");
                }).catch(err=>{
                });
            }
        },
        send_select(){
            if(this.selected.length==0){
                this.$message.error("请选择相对应的数据！");
            }else{
                let arr = [];
                for(let item of this.selected){
                    arr.push(item.id);
                }
                this.is_post = true;
                request.post("finance/send_to_customer",{dzdIds:arr}).then(res=>{
                    this.getData();
                    this.$message.success("操作成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            }
        },
        getData(is_init = false){
            if(!is_init){
                this.is_post = true;
                this.is_loading = true;
            }
            request.post("finance/account_statement_list",this.selectForm).then(res=>{
                this.data = res.data.list;
                this.total = res.data.total;
                if(is_init){
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-135;
                    this.showtable = true;
                    this.is_ok = true;
                }else{
                    this.is_post = false;
                    this.is_loading = false;
                }
            }).catch(err=>{
                if(is_init){
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-135;
                    this.showtable = true;
                    this.is_ok = true;
                }else{
                    this.is_post = false;
                    this.is_loading = false;
                }
            });
        },
        has_permission(permission){
            return this.permissions.includes(permission);
        },
        handleSelectionChange(arr){
            this.selected = arr;
        },
        selectComMethod(name){
            if(name.length > 1){
                this.is_select = true;
                request.get("company/option?keyword="+name).then(res=>{
                    if(res.data && res.data.length > 0){
                        this.componys = res.data;
                    }else{
                        this.componys = [];
                    }
                    this.is_select = false;
                }).catch(err=>{
                    this.is_select = false;
                });
            }
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        getCom(){
            request.get("company/option").then(res=>{
                // console.log(JSON.stringify(res.data))
                // this.company = [{id:0,name:"全部"},...res.data];
                for(let item of res.data){
                    let tempData = {
                        key:item.id,
                        label:item.name
                    }
                    this.company.push(tempData);
                    this.all_com.push(item.id);
                }
            }).catch(err=>{
                console.log(err);
            });
        },
        selectChange(v){
            this.addForm.companyIds = v;
            // if(v.includes(0)){
            //     this.addForm.companyIds = [0];
            //     this.$refs["add_com"].blur();
            // }
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
        addSubmit(){
            this.$refs["addForm"].validate(valid=>{
                if(!valid) return false;
                this.is_post = true;
                let data = deepClone(this.addForm);
                if(data.companyIds.includes(0)){
                    data.companyIds = this.all_com;
                }
                this.$confirm('是否确认生成对账单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request.post("finance/generate_dzd",data).then(res=>{
                        this.is_post = false;
                        this.getData();
                        this.$message.success(res.data);
                        this.add_dialog = false;
                        this.addForm.companyIds = [];
                        this.addForm.endDate='';
                        this.selectComIDs =[];
                    }).catch(err=>{
                        this.is_post = false;
                        this.$message.error(res.msg);
                    });
                });

                // request.post("finance/generate_account_statement_tip",data).then(res=>{
                //     this.$confirm(res.data.tip, '提示', {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(() => {
                //         request.post("finance/generate_account_statement_confirm",data).then(res=>{
                //             this.is_post = false;
                //             this.getData();
                //             this.$message.success(res.msg);
                //             this.add_dialog = false;
                //             this.addForm.companyIds = [];
                //         }).catch(err=>{
                //             console.log(err);
                //             this.is_post = false;
                //         });
                //     });
                // }).catch(err=>{
                //     this.is_post = false;
                // });
            });
        }
    },
    created() {
        this.getCom();
        this.getData(true);
    },
    mounted() {
        this.getCompany();
    }
}
</script>

<style scoped lang="scss">
</style>

<style>
.el-transfer-panel{
    width: 300px !important;
}
</style>
